"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalContext = void 0;
exports.PortalProvider = PortalProvider;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _canUseDom = _interopRequireDefault(require("./../_utils/can-use-dom"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PortalContext = /*#__PURE__*/(0, _react.createContext)({
  node: _canUseDom["default"] ? document.body : null
});

/**
 * Portal provider component used to provide node to render react portal
 */
exports.PortalContext = PortalContext;
function PortalProvider(_ref) {
  var children = _ref.children,
    node = _ref.node;
  return /*#__PURE__*/_react["default"].createElement(PortalContext.Provider, {
    value: {
      node: node
    }
  }, children);
}

/**
 * ⚠️ Important: Keep these prop's in-sync with the local portal-provider.d.ts
 * definition file (other than `node` which is more specific in the .d.ts file
 * than what we can do here in prop-types for both browsers + node)
 */
PortalProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The components to apply the theme to.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * Target node for react portal for component to embed option list.
   */
  node:
  // If we're in an environment that knows what an HTMLElement and ShadowRoot is, use those types
  typeof HTMLElement !== "undefined" && typeof ShadowRoot !== "undefined" ? _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(HTMLElement), _propTypes["default"].instanceOf(ShadowRoot)]).isRequired :
  // Otherwise, be permissive
  _propTypes["default"].any.isRequired
} : {};